
  import {computed, defineComponent, PropType, reactive, toRefs} from "vue";
  import {integer, maxValue, minValue} from "@vuelidate/validators";
  import useVuelidate from "@vuelidate/core";
  import {OrderOperator} from "@/views/Orders/Operators/OrderOperators.vue";
  import {orderId} from "@/RouterUtils";
  import {AsyncState} from "@/enums";
  import {init} from "@/views/Orders/Operators/OrderOperatorsComposable";

  export default defineComponent({
    name: "OrderOperatorsListOperatorNumber",
    props: {
      editable: {
        type: Boolean,
        default: () => false
      },
      item: {
        type: Object as PropType<OrderOperator>,
        default: () => null,
      }
    },
    setup (props, context) {
      const initialState = {
        operatorNumber: props.item.operatorNumber
      };

      const {
        state: generalState,
        createOrUpdate,
        isLoading,
        isError,
        isSuccess,
        $externalResults,
      } = init();

      const state = reactive({ ...initialState });

      const rules = computed(() => ({
        operatorNumber: {
          integer,
          minValue: minValue(1010),
          maxValue: maxValue(2200)
        }
      }));

      const v$ = useVuelidate(rules, state, { $externalResults });

      const update = () => {
        v$.value.$clearExternalResults();
        v$.value.$validate();

        if (props.editable && props.item.operatorNumber != state.operatorNumber) {
          if (!invalid.value) {
            createOrUpdate(orderId.value, {
              id: props.item.id,
              employee: props.item.employee,
              operatorNumber: state.operatorNumber,
              numberOfPositions: props.item.numberOfPositions
            })
              .then(updated => {
                context.emit("updated", updated);
              })
              .catch(error => {
                $externalResults.value = {
                  operatorNumber: error.response.data.title
                };
              });
          } else {
            generalState.asyncState = AsyncState.ERROR;
          }
        } else {
          generalState.asyncState = AsyncState.SUCCESS;
        }
      };

      const invalid = computed(() => {
        return v$.value.$dirty && v$.value.$error;
      });

      const errorMessage = computed(() => {
        return invalid.value ? v$.value.$errors[0].$message : null;
      });

      return {
        ...toRefs(state),
        isLoading,
        isError,
        isSuccess,
        errorMessage,
        update
      };
    }
  });
